export default "__VITE_ASSET__e4KuYOxH__"